
















import Vue from "vue";
import Component from "vue-class-component";
import { LLayerGroup } from "vue2-leaflet";
import AisTarget from "./AisTarget.vue";
import bboxFilter from "@/utils/bbox_filter";
import { icon, LatLng, latLng } from "leaflet";
import { ISar } from "@/store/targets/models";
import { targets, maps } from "@/store";
import { MutationTypes } from "@/store/mutations-types";

const sarIconUrl = require("../../../assets/icons/ais/ais-sar.svg")

@Component({
  components: {
    LLayerGroup,
    AisTarget,
  },
})
export default class Sars extends Vue {
  timer: number = 0;

  //methods
  coordsBuilder(sar: ISar):LatLng {
    const lon = sar.position.coordinates[0];
    const lat = sar.position.coordinates[1];
    return latLng(lat, lon)
  }
  sarInfo(sar: ISar) {
    return {
      mmsi: sar.mmsi,
      name: sar.statics.name,
      callsign: sar.statics.callsign,
      destination: sar.statics.destination,
      altitude: sar.alt,
    };
  }
  clickHandler(mmsi: number) {
    if (maps.getters.measurementActivated) {
      maps.commit(MutationTypes.ADD_MEASUREMENT_POINT, {
        tipo: "sar",
        data: mmsi,
      });
    }
  }

  //computed
  get sarList() {
    return targets.getters.sarList;
  }

  get selectedSar() {
    return targets.getters.selectedSar;
  }

  get filteredSars() {
    return bboxFilter(this.sarList, "position");
  }
  get iconGenerator() {
    return icon({
      iconUrl: sarIconUrl,
      iconSize: [60, 60],
    });
  }
}
